/**
 * Keep Work mode latched for the current conversation only.
 *
 * A store merge can drop `flags.isCoworkerSession` mid-resume; latching
 * prevents the thread from flipping to Chat and looping the handover fade.
 * The latch must reset when `/c/:id` is reused for a different conversation,
 * or a Chat thread inherits Work chrome (follow-up composer, "- Work" title).
 */
export function nextWorkLatch({ conversationId, flaggedWork, latchedConversationId, latchedWork }) {
  if (conversationId !== latchedConversationId) {
    return { latchedConversationId: conversationId, latchedWork: !!flaggedWork };
  }
  return { latchedConversationId, latchedWork: !!(flaggedWork || latchedWork) };
}
